export const environment = {
  production: true,
  version: '2.22.1-25.04',
  apiBasePath: '/api',
  agentApiBasePath: '/api/agent',
  imt_resources_url: 'https://operator-logo.transferto.com/logo-',
  legal_age: 18,
  apiTokenExpirationTimeInHours: 2,
  seconds_idle: 5 * 60,
  seconds_timeout: 5 * 60,
  outlookMailUrl: 'https://outlook.live.com',
  gmailWebUrl: 'https://mail.google.com',
  wpEnabled: true,
  wpSpecificURL: false,
  imtWordpressBaseUrlNoProtocol: 'moneytrans.eu',
  imtWordpressBaseUrl: 'https://www.moneytrans.eu/',
  wpSiteCookieKey: 'mt-site',
  wpSiteLanguageCookie: 'wp-wpml_current_language',
  imtPwaUrlProtocol: 'imoneytrans://login',
  countryActiveLimitDateExpiry: ['FRA', 'NLD'],
  documentTypeActiveLimitDateExpiry: ['LRPT'],
  recaptchaApiSiteKey: '6Ld3ZHQpAAAAAL3a2wVb_KD-gqX5lCUb9b-7rvyY',
  PartnerDisabledNewSmiles: [],
  sentryDns:
    'https://a839288fe815422cb016bc1d608d5391@o4504723444137984.ingest.sentry.io/4504793659932672',
  skeletonTime: 200,
  freshChatUrl: 'https://moneytrans.freshchat.com',
  freshChatTokens: {
    ES: 'ac81337e-a036-4830-82cf-0872801ce192',
    FR: 'ac81337e-a036-4830-82cf-0872801ce192',
    BE: 'ac81337e-a036-4830-82cf-0872801ce192',
    IT: 'ac81337e-a036-4830-82cf-0872801ce192',
    UK: 'ac81337e-a036-4830-82cf-0872801ce192',
    others: 'ac81337e-a036-4830-82cf-0872801ce192',
  },
  widgetUuid: {
    ES: '1b1100de-ad26-4ea1-8b36-87e427ff2c03',
    FR: 'c70635e3-e4a3-4284-8a53-7059000f50f4',
    BE: 'a8c2e908-3ce7-4c0f-af8d-3c18114bb216',
    IT: 'd6045801-c06f-4518-ba3f-457293d77d27',
    UK: '93a6e6a9-c945-425b-a96c-cf7cd623d112',
    Default: '',
  },
  useSecureCookies: true,
};
